import { render, staticRenderFns } from "./QuickView.vue?vue&type=template&id=bd484914&scoped=true&"
import script from "./QuickView.vue?vue&type=script&lang=js&"
export * from "./QuickView.vue?vue&type=script&lang=js&"
import style0 from "./QuickView.vue?vue&type=style&index=0&id=bd484914&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd484914",
  null
  
)

export default component.exports